export default "__VITE_ASSET__2c26e68d__"